export class BreakerContext {
  breakeableProviders: symbol[];
}
